import classNames from 'classnames';
import * as React from 'react';

type FieldContainerProps = {
  children: React.ReactNode;
  className?: string;
  value?: string | React.ReactNode;
  label?: string | React.ReactNode;
  id?: string;
  onClick?: () => void;
  childrenClass?: string;
};

const FieldContainer = (props: FieldContainerProps) => {
  const { label, value } = props;

  const containerClasses = classNames(
    'relative w-full ev-sm:max-w-[284px] min-h-[2.5rem] py-2 pl-4 flex rounded items-center grow-0',
    props.className,
    {
      'bg-white': !props.className,
      // if the value is a complex structure we want it to be "sticked" to the props.children
      'pr-9': typeof value !== 'string',
      'pr-12': typeof value === 'string'
    }
  );

  const childrenClasses = classNames(
    {
      'absolute top-2 right-3': !props.childrenClass
    },
    props.childrenClass
  );

  return (
    <div id={props?.id} className={containerClasses} onClick={props?.onClick}>
      <div className="flex w-full justify-between flex-wrap gap-1 items-center">
        {label && <span className="text-navy-blue-2 font-bold">{label}</span>}
        {value && <div className="text-ev-dark-purple font-bold">{value}</div>}
      </div>
      <div className={childrenClasses}>{props.children}</div>
    </div>
  );
};

export default FieldContainer;
